import React, { useEffect, useState } from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import Problems from '../components/Problems';
import HowItWorks from '../components/HowItWorks';
import Portfolio from '../components/Portfolio';
import Testimonials from '../components/Testimonials';
import Capabilities from '../components/Capabilities';
import Pricing from '../components/Pricing';
import FAQ from '../components/FAQ';
import Footer from '../components/Footer';
import { Toaster } from '../components/ui/toaster';

const Home = () => {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="relative w-full min-h-screen bg-black text-white overflow-hidden">
      <Navbar />
      <Hero scrollY={scrollY} />
      <Problems />
      <HowItWorks />
      <Portfolio />
      <Testimonials />
      <Capabilities />
      <Pricing />
      <FAQ />
      <Footer />
      <Toaster />
    </div>
  );
};

export default Home;